import { render } from "./AdminHeader.vue?vue&type=template&id=40c28f74&scoped=true"
import script from "./AdminHeader.vue?vue&type=script&lang=js"
export * from "./AdminHeader.vue?vue&type=script&lang=js"

import "./AdminHeader.vue?vue&type=style&index=0&id=40c28f74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c28f74"]])

export default __exports__